import upMaterialComponent from './upMaterial'
import upMaterialUuidComponent from './upMaterialUuid'

const upMaterial = {
  install:function(Vue){
    Vue.component('upMaterial',upMaterialComponent);
    Vue.component('upMaterialUuid',upMaterialUuidComponent);
  }
};

export default upMaterial



// WEBPACK FOOTER //
// ./src/components/upMaterial/index.js